import * as React from "react";
import { createColumnHelper } from "@tanstack/react-table";

import { customCreateColumnHelper } from "src/core/dashboard/components/widgets/table/customColumnHelper";
import { CreditTopOffendersData } from "src/core/dashboard/api/widget-data.api";
import { Text } from "src/library/components/Text";
import { formatDropName } from "src/core/drops/utils/format-drop-name";
import { formatCustomerName } from "src/core/customers/utils/format-customer-name";

export const getCreditTopOffendersTableColumns = () => {
  const customColumnHelper = customCreateColumnHelper<CreditTopOffendersData>();
  const columnHelper = createColumnHelper<CreditTopOffendersData>();

  return [
    customColumnHelper.standardTextColumn(columnHelper, "branchName", {
      header: "Branch",
      enableSorting: false,
      cell: ({ row }) => (
        <Text>
          <>
            {formatDropName({
              name: row.original.branchName,
              branchNumber: row.original.branchNumber
            })}
          </>
        </Text>
      )
    }),
    customColumnHelper.standardTextColumn(columnHelper, "customerName", {
      header: "Customer",
      enableSorting: false,
      cell: ({ row }) => {
        return (
          <Text>
            <>
              {formatCustomerName({
                name: row.original.customerName,
                accountNumber: row.original.customerNumber
              })}
            </>
          </Text>
        );
      }
    }),
    customColumnHelper.numberColumn(columnHelper, "quantityRequested", {
      header: "Quantity Requested",
      enableSorting: false
    }),
    customColumnHelper.priceColumn(columnHelper, "requestedValue", { header: "Requested Value" }),
    customColumnHelper.numberColumn(columnHelper, "quantityApproved", { header: "Quantity Approved" }),
    customColumnHelper.priceColumn(columnHelper, "approvedValue", { header: "Approved Value" }),
    customColumnHelper.standardTextColumn(columnHelper, "rejected", { header: "Rejected" })
  ];
};